import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-national-geographic', 'BrandNationalGeographic', [["path",{"d":"M7 3h10v18h-10l0 -18"}]]);